import RouteEnum from "constants/RouteEnum";
import IStore from "models/IStore";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./HeaderControl.css";

const HeaderControl: React.FC = () => {
  const { t } = useTranslation();
  const user = useSelector((state: IStore) => state.auth.user);
  const navigate = useNavigate();

  return (
    <div className="nav-item header-control">
      <div className="header-action">
        <ul>
          <li className="login-btn cs-login-btn">
            <button 
              className="item-btn header-login-button" 
              onClick={() => navigate(user ? RouteEnum.ProfileCreate : RouteEnum.Login)}
            >
              <i className="fas fa-user"></i>
              {t("header.header-control.login")}
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default HeaderControl;
